import { render } from "./Mikomi_Type_Other.vue?vue&type=template&id=dd250db4"
import script from "./Mikomi_Type_Other.vue?vue&type=script&lang=js"
export * from "./Mikomi_Type_Other.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__